import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { injectIntl } from 'react-intl'
import cx from 'classnames'

import { Container, Content, PageTitle } from 'src/components/Layout'
import { FooterActionsParent } from 'src/components/Layout/Footer/FooterActions'
import Button from 'src/components/Button/Button'
import { Loader } from 'src/components/Loader'
import { isEmpty, getKioskDocument } from 'src/utils/helpers'
import PolicyCard from '../PolicyCard'
import PolicyItem from './PolicyItem'

import { Box, Text, Flex } from '@chakra-ui/react'

import styles from './styles.module.less'
import intlMessages from '../translations'

class PolicySummaryView extends Component {
  componentDidMount() {
    const { policy, history, getPolicyDetails, isWidgetState } = this.props
    // Redirect back if currently open policy is not set
    if (!policy) {
      history.push('/documents')
      return false
    }

    // Load policy details
    if (typeof getPolicyDetails === 'function') {
      // TODO: Check if we should handle response of this request
      getPolicyDetails(policy.id)
    }

    if (isWidgetState) {
      const kioskDocument = getKioskDocument()
      const kioskWidgetContainer = kioskDocument.querySelector('.app-main-content__widget')
      kioskWidgetContainer.scrollTo(0, 0)
    } else {
      const mainContainer =
        window.innerWidth < 900
          ? document.querySelector('.app-main-content')
          : document.querySelector('.app-main-container')
      mainContainer.scrollTo(0, 0)
    }
  }

  createSlip = e => {
    e.preventDefault()

    this.props.history.push('/documents/create-slip')
  }

  render() {
    const {
      intl,
      history,
      policy,
      loadingPolicyDetails,
      policyDetails,
      countryIsoCode,
      features,
    } = this.props

    const foundedFeature = features.find(f => f.id == 'documents')
    const title =
      foundedFeature && foundedFeature.title
        ? foundedFeature.title
        : intl.formatMessage(intlMessages.documentsHeadline)

    const isSlipCreateAllowed =
      !isEmpty(policyDetails) &&
      policyDetails.hasOwnProperty('isSlipCreateAllowed') &&
      policyDetails.isSlipCreateAllowed === true

    const numActionButtons = isSlipCreateAllowed ? 1 : 0

    const layoutClassNames = cx({
      [styles.layoutWithOverlayPolicySummary]: false,
      [styles.layoutWithFixedPolicySummary]: false,
    })

    return (
      <Flex className={layoutClassNames}>
        <Content>
          <PageTitle title={'Policy Summary'} subtitle={title} />
          <Container className={styles.container}>
            <Box mt={'20px'} className={styles.policyFullView}>
              <div className={styles.policySummaryHolder}>
                <PolicyCard
                  policy={policy}
                  intl={intl}
                  history={history}
                  styleVariation='full-view'
                />
              </div>
              {loadingPolicyDetails ? (
                <Loader styleVariation='staticWithHeight' />
              ) : policyDetails ? (
                <div className={styles.policyDetails}>
                  <FooterActionsParent numButtons={numActionButtons}>
                    {policyDetails.hasOwnProperty('policyItems') &&
                    policyDetails.policyItems.length > 0 ? (
                      <div className={styles.policyItemsContainer}>
                        {policyDetails.policyItems.map((item, key) => (
                          <PolicyItem
                            key={key}
                            policy={policyDetails}
                            item={item}
                            intl={intl}
                            history={history}
                          />
                        ))}
                      </div>
                    ) : (
                      ''
                    )}
                    {policyDetails.hasOwnProperty('premiums') &&
                    policyDetails.premiums.length > 0 ? (
                      <div className={styles.policyPremiums}>
                        {policyDetails.premiums.map((premium, key) => (
                          <Flex key={key} align={'center'} justify={'space-between'}>
                            <Text mb={'8px'} fontSize={'16px'} fontStyle={'italic'} variant='card'>
                              {premium.label}
                            </Text>
                            <Text
                              fontSize={'16px'}
                              fontStyle={'italic'}
                              fontWeight={'bold'}
                              variant='card'
                            >
                              {premium.value}
                            </Text>
                          </Flex>
                        ))}
                      </div>
                    ) : (
                      ''
                    )}

                    {isSlipCreateAllowed ? (
                      // eslint-disable-next-line react/no-unknown-property
                      <div numButtons={numActionButtons} className={styles.policyActions}>
                        <Button
                          type='submit'
                          onClick={this.createSlip}
                          className={styles.policyActionBtn}
                        >
                          {countryIsoCode && countryIsoCode.toLowerCase() === 'ca'
                            ? intl.formatMessage(intlMessages.policyCreateCreatePinkSlip)
                            : intl.formatMessage(intlMessages.policyCreateCreateEIDSlip)}
                        </Button>
                      </div>
                    ) : (
                      ''
                    )}
                  </FooterActionsParent>
                </div>
              ) : (
                ''
              )}
            </Box>
          </Container>
        </Content>
      </Flex>
    )
  }
}

export default withRouter(injectIntl(PolicySummaryView))
